"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AudioConfig_1 = require("./Audio/AudioConfig");

exports.AudioConfig = AudioConfig_1.AudioConfig;

var AudioStreamFormat_1 = require("./Audio/AudioStreamFormat");

exports.AudioStreamFormat = AudioStreamFormat_1.AudioStreamFormat;

var AudioInputStream_1 = require("./Audio/AudioInputStream");

exports.AudioInputStream = AudioInputStream_1.AudioInputStream;
exports.PullAudioInputStream = AudioInputStream_1.PullAudioInputStream;
exports.PushAudioInputStream = AudioInputStream_1.PushAudioInputStream;

var CancellationReason_1 = require("./CancellationReason");

exports.CancellationReason = CancellationReason_1.CancellationReason;

var PullAudioInputStreamCallback_1 = require("./Audio/PullAudioInputStreamCallback");

exports.PullAudioInputStreamCallback = PullAudioInputStreamCallback_1.PullAudioInputStreamCallback;

var KeywordRecognitionModel_1 = require("./KeywordRecognitionModel");

exports.KeywordRecognitionModel = KeywordRecognitionModel_1.KeywordRecognitionModel;

var SessionEventArgs_1 = require("./SessionEventArgs");

exports.SessionEventArgs = SessionEventArgs_1.SessionEventArgs;

var RecognitionEventArgs_1 = require("./RecognitionEventArgs");

exports.RecognitionEventArgs = RecognitionEventArgs_1.RecognitionEventArgs;

var OutputFormat_1 = require("./OutputFormat");

exports.OutputFormat = OutputFormat_1.OutputFormat;

var IntentRecognitionEventArgs_1 = require("./IntentRecognitionEventArgs");

exports.IntentRecognitionEventArgs = IntentRecognitionEventArgs_1.IntentRecognitionEventArgs;

var RecognitionResult_1 = require("./RecognitionResult");

exports.RecognitionResult = RecognitionResult_1.RecognitionResult;

var SpeechRecognitionResult_1 = require("./SpeechRecognitionResult");

exports.SpeechRecognitionResult = SpeechRecognitionResult_1.SpeechRecognitionResult;

var IntentRecognitionResult_1 = require("./IntentRecognitionResult");

exports.IntentRecognitionResult = IntentRecognitionResult_1.IntentRecognitionResult;

var LanguageUnderstandingModel_1 = require("./LanguageUnderstandingModel");

exports.LanguageUnderstandingModel = LanguageUnderstandingModel_1.LanguageUnderstandingModel;

var SpeechRecognitionEventArgs_1 = require("./SpeechRecognitionEventArgs");

exports.SpeechRecognitionEventArgs = SpeechRecognitionEventArgs_1.SpeechRecognitionEventArgs;

var SpeechRecognitionCanceledEventArgs_1 = require("./SpeechRecognitionCanceledEventArgs");

exports.SpeechRecognitionCanceledEventArgs = SpeechRecognitionCanceledEventArgs_1.SpeechRecognitionCanceledEventArgs;

var TranslationRecognitionEventArgs_1 = require("./TranslationRecognitionEventArgs");

exports.TranslationRecognitionEventArgs = TranslationRecognitionEventArgs_1.TranslationRecognitionEventArgs;

var TranslationSynthesisEventArgs_1 = require("./TranslationSynthesisEventArgs");

exports.TranslationSynthesisEventArgs = TranslationSynthesisEventArgs_1.TranslationSynthesisEventArgs;

var TranslationRecognitionResult_1 = require("./TranslationRecognitionResult");

exports.TranslationRecognitionResult = TranslationRecognitionResult_1.TranslationRecognitionResult;

var TranslationSynthesisResult_1 = require("./TranslationSynthesisResult");

exports.TranslationSynthesisResult = TranslationSynthesisResult_1.TranslationSynthesisResult;

var ResultReason_1 = require("./ResultReason");

exports.ResultReason = ResultReason_1.ResultReason;

var SpeechConfig_1 = require("./SpeechConfig");

exports.SpeechConfig = SpeechConfig_1.SpeechConfig;

var SpeechTranslationConfig_1 = require("./SpeechTranslationConfig");

exports.SpeechTranslationConfig = SpeechTranslationConfig_1.SpeechTranslationConfig;

var PropertyCollection_1 = require("./PropertyCollection");

exports.PropertyCollection = PropertyCollection_1.PropertyCollection;

var PropertyId_1 = require("./PropertyId");

exports.PropertyId = PropertyId_1.PropertyId;

var Recognizer_1 = require("./Recognizer");

exports.Recognizer = Recognizer_1.Recognizer;

var SpeechRecognizer_1 = require("./SpeechRecognizer");

exports.SpeechRecognizer = SpeechRecognizer_1.SpeechRecognizer;

var IntentRecognizer_1 = require("./IntentRecognizer");

exports.IntentRecognizer = IntentRecognizer_1.IntentRecognizer;

var TranslationRecognizer_1 = require("./TranslationRecognizer");

exports.TranslationRecognizer = TranslationRecognizer_1.TranslationRecognizer;

var Translations_1 = require("./Translations");

exports.Translations = Translations_1.Translations;

var NoMatchReason_1 = require("./NoMatchReason");

exports.NoMatchReason = NoMatchReason_1.NoMatchReason;

var NoMatchDetails_1 = require("./NoMatchDetails");

exports.NoMatchDetails = NoMatchDetails_1.NoMatchDetails;

var TranslationRecognitionCanceledEventArgs_1 = require("./TranslationRecognitionCanceledEventArgs");

exports.TranslationRecognitionCanceledEventArgs = TranslationRecognitionCanceledEventArgs_1.TranslationRecognitionCanceledEventArgs;

var IntentRecognitionCanceledEventArgs_1 = require("./IntentRecognitionCanceledEventArgs");

exports.IntentRecognitionCanceledEventArgs = IntentRecognitionCanceledEventArgs_1.IntentRecognitionCanceledEventArgs;

var CancellationDetails_1 = require("./CancellationDetails");

exports.CancellationDetails = CancellationDetails_1.CancellationDetails;

var CancellationErrorCodes_1 = require("./CancellationErrorCodes");

exports.CancellationErrorCode = CancellationErrorCodes_1.CancellationErrorCode;

var ConnectionEventArgs_1 = require("./ConnectionEventArgs");

exports.ConnectionEventArgs = ConnectionEventArgs_1.ConnectionEventArgs;

var Connection_1 = require("./Connection");

exports.Connection = Connection_1.Connection;

var PhraseListGrammar_1 = require("./PhraseListGrammar");

exports.PhraseListGrammar = PhraseListGrammar_1.PhraseListGrammar;